// API Configuration
export const API_CONFIG = {
  // Patdraw API URL - can be overridden by environment variable
  PATDRAW_API_URL: import.meta.env?.VITE_PATDRAW_API_URL || 'https://patdraw-dev.up.railway.app',
  
  // Patdraw Frontend URL - for opening the Patdraw application
  // URL is set at build time based on git branch (see rollup.config.js)
  // vercel-new-gcp -> figure-pilot.fearn.ai
  // vercel-dev-gcp -> patdraw-gcp-git-vercel-dev-gcp-fearn.vercel.app
  // default -> figure-demo.fearn.ai
  PATDRAW_FRONTEND_URL: import.meta.env?.VITE_PATDRAW_FRONTEND_URL || 'https://figure-demo.fearn.ai',
  
  // API endpoints
  ENDPOINTS: {
    FIGURES: '/api/figures',
    FIGURE_BY_ID: (id) => `/api/figures/${id}`,
    FIGURE_IMAGE: (id, size = 'full') => `/api/figures/${id}/image?size=${size}`,
    SHEET_ORDER: '/api/presentation/sheet-order'
  },
  
  // Cache configuration
  CACHE: {
    FIGURES_TTL: 60000, // 1 minute
    FIGURE_TTL: 300000, // 5 minutes
    IMAGE_TTL: 3600000  // 1 hour
  }
};